export default class MenuItem {
  public title: string
  public icon: string
  public path: string

  constructor(title: string, icon: string, path: string) {
    this.title = title
    this.icon = icon
    this.path = path
  }
}
